import $ from 'jquery';

//录制视频
let mediaRecorder;
let recordedBlobs;

var HZRecorder = function (stream, config) {
    config = config || {};
    config.sampleBits = config.sampleBits || 16; //采样数位 8, 16 
    config.sampleRate = config.sampleRate || 16000; //(44100 / 3); //采样率(1/6 44100)

    //创建一个音频环境对象
    var audioContext = window.AudioContext || window.webkitAudioContext;
    var context = new audioContext();

    //将声音输入这个对像
    var audioInput = context.createMediaStreamSource(stream);

    //设置音量节点
    var volume = context.createGain();
    audioInput.connect(volume);

    //创建缓存，用来缓存声音
    var bufferSize = 4096;

    // 创建声音的缓存节点，createScriptProcessor方法的
    // 第二个和第三个参数指的是输入和输出都是双声道。
    var recorder = context.createScriptProcessor(bufferSize, 2, 2);

    var audioData = {
        size: 0 //录音文件长度
        , buffer: [] //录音缓存
        , cutSize: 0 //上一次切割完到录音文件的长度
        , cutLineOffset: 0 //每次切割到的录音文件偏移
        , inputSampleRate: context.sampleRate //输入采样率
        , inputSampleBits: 16 //输入采样数位 8, 16
        , outputSampleRate: config.sampleRate //输出采样率
        , oututSampleBits: config.sampleBits //输出采样数位 8, 16
        , input: function (data) {
            // console.log('data:', new Float32Array(data))
            this.buffer.push(new Float32Array(data));
            this.size += data.length;
            window.maxVolumn = Math.max.apply(null, data);
            // console.log(window.maxVolumn)
        }
        , compress: function (time) { //合并压缩
            //合并
            var curWxSize = this.size;
            var curWxBuffer = this.buffer;
            var need_copy_size = time ? (curWxSize - this.cutSize) : curWxSize;
            var data = new Float32Array(need_copy_size);
            var offset = 0;
            var copyline_count = 0;
            for (var i = (time ? this.cutLineOffset : 0); i < curWxBuffer.length && offset < need_copy_size; i++) {
                data.set(curWxBuffer[i], offset);
                offset += curWxBuffer[i].length;
                copyline_count += 1;
            }
            this.cutLineOffset += copyline_count; //= curWxBuffer.length;
            this.cutSize += offset;
            // console.log("time=" + time + ";this.size=" + this.size + "; curWxSize=" + curWxSize + "; need_copy_size:" + need_copy_size + "; offset=" + offset + '; curWxBuffer=' + curWxBuffer.length + '; cutLineOffset=' + this.cutLineOffset);

            //压缩
            // var compression = parseInt(this.inputSampleRate / this.outputSampleRate, 10);
            // var length = data.length / compression;
            // var result = new Float32Array(length);
            // var index = 0,
            //     j = 0;
            // while (index < length) {
            //     result[index] = data[j];
            //     j += compression;
            //     index++;
            // }

            //only for samplerate 44100->16000
            var length = parseInt(data.length * 16000 / 44100, 10);
            var result = new Float32Array(length);
            var index = 0, j = 0;
            while (index < length && j < data.length) {
                if (j % 3 == 0) {
                    result[index] = data[j];
                    index++;
                }
                if (j % 36 == 0 && j < data.length - 1) {
                    result[index] = data[j + 1];
                    index++;
                }
                if (j % 588 == 0 && j < data.length - 2) {
                    result[index] = data[j + 2];
                    index++;
                }
                j += 3;
            }

            return result;
        }
        , compressAll: function () { //合并压缩
            //合并
            var size = this.size;
            var buffer = this.buffer;
            var data = new Float32Array(size);
            // console.log('===', data)
            var offset = 0;
            for (var i = 0; i < buffer.length && offset < size; i++) {
                data.set(buffer[i], offset);
                offset += buffer[i].length;
            }
            // console.log("xunfei---this.size=" + this.size + "; offset=" + offset + '; buffer=' + buffer.length);

            //压缩
            // var compression = parseInt(this.inputSampleRate / this.outputSampleRate, 10);
            // var length = data.length / compression;
            // var result = new Float32Array(length);
            // var index = 0,
            //     j = 0;
            // while (index < length) {
            //     result[index] = data[j];
            //     j += compression;
            //     index++;
            // }

            //only for samplerate 44100->16000
            var length = parseInt(data.length * 16000 / 44100, 10);
            var result = new Float32Array(length);
            var index = 0, j = 0;
            while (index < length && j < data.length) {
                if (j % 3 == 0) {
                    result[index] = data[j];
                    index++;
                }
                if (j % 36 == 0 && j < data.length - 1) {
                    result[index] = data[j + 1];
                    index++;
                }
                if (j % 588 == 0 && j < data.length - 2) {
                    result[index] = data[j + 2];
                    index++;
                }
                j += 3;
            }
            return result;
        }
        , encodePCM: function (time) {
            var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
            var bytes = this.compress(time);
            var dataLength = bytes.length * (sampleBits / 8);
            var buffer = new ArrayBuffer(dataLength);
            var data = new DataView(buffer);
            var offset = 0;

            // 写入采样数据
            if (sampleBits === 8) {
                for (var i = 0; i < bytes.length; i++, offset++) {
                    var s = Math.max(- 1, Math.min(1, bytes[i]));
                    var val = s < 0 ? s * 0x8000 : s * 0x7FFF;
                    val = parseInt(255 / (65535 / (val + 32768)), 10);
                    data.setInt8(offset, val, true);
                }
            } else {
                for (var i = 0; i < bytes.length; i++, offset += 2) {
                    var s = Math.max(- 1, Math.min(1, bytes[i]));
                    data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                }
            }
            return new Blob([data], {
                type: 'audio/wav'
            });
            // return data;
        }
        , encodeWAV: function () {
            var sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate);
            var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
            var bytes = this.compressAll();
            var dataLength = bytes.length * (sampleBits / 8);
            var buffer = new ArrayBuffer(44 + dataLength);
            var data = new DataView(buffer);

            var channelCount = 1; //单声道
            var offset = 0;

            var writeString = function (str) {
                for (var i = 0; i < str.length; i++) {
                    data.setUint8(offset + i, str.charCodeAt(i));
                }
            };

            // 资源交换文件标识符
            writeString('RIFF');
            offset += 4;
            // 下个地址开始到文件尾总字节数,即文件大小-8 
            data.setUint32(offset, 36 + dataLength, true);
            offset += 4;
            // WAV文件标志 
            writeString('WAVE');
            offset += 4;
            // 波形格式标志
            writeString('fmt ');
            offset += 4;
            // 过滤字节,一般为 0x10 = 16
            data.setUint32(offset, 16, true);
            offset += 4;
            // 格式类别 (PCM形式采样数据) 
            data.setUint16(offset, 1, true);
            offset += 2;
            // 通道数
            data.setUint16(offset, channelCount, true);
            offset += 2;
            // 采样率,每秒样本数,表示每个通道的播放速度
            data.setUint32(offset, sampleRate, true);
            offset += 4;
            // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8 
            data.setUint32(offset, channelCount * sampleRate * (sampleBits / 8), true);
            offset += 4;
            // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
            data.setUint16(offset, channelCount * (sampleBits / 8), true);
            offset += 2;
            // 每样本数据位数
            data.setUint16(offset, sampleBits, true);
            offset += 2;
            // 数据标识符
            writeString('data');
            offset += 4;
            // 采样数据总数,即数据总大小-44
            data.setUint32(offset, dataLength, true);
            offset += 4;
            // 写入采样数据
            if (sampleBits === 8) {
                for (var i = 0; i < bytes.length; i++, offset++) {
                    var s = Math.max(- 1, Math.min(1, bytes[i]));
                    var val = s < 0 ? s * 0x8000 : s * 0x7FFF;
                    val = parseInt(255 / (65535 / (val + 32768)), 10);
                    data.setInt8(offset, val, true);
                }
            } else {
                for (var i = 0; i < bytes.length; i++, offset += 2) {
                    var s = Math.max(- 1, Math.min(1, bytes[i]));
                    data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                }
            }
            return new Blob([data], {
                type: 'audio/wav'
            });
            // return data;
        }
    };

    //开始录音
    this.start = function () {
        audioInput.connect(recorder);
        recorder.connect(context.destination);
    };

    //停止
    this.stop = function () {
        recorder.disconnect();
    };

    //获取音频文件
    this.getBlob = function (time) {
        // this.stop();
        return time ? audioData.encodePCM(time) : audioData.encodeWAV();
    };

    //回放
    this.play = function (audio) {
        //兼容
        window.URL = window.URL || window.webkitURL;
        audio.src = window.URL.createObjectURL(this.getBlob());
    };

    //上传
    this.upload = function (url, callback) {
        var fd = new FormData();
        fd.append('audioData', this.getBlob());
        var xhr = new XMLHttpRequest();
        if (callback) {
            xhr.upload.addEventListener('progress',
                function (e) {
                    callback('uploading', e);
                },
                false);
            xhr.addEventListener('load',
                function (e) {
                    callback('ok', e);
                },
                false);
            xhr.addEventListener('error',
                function (e) {
                    callback('error', e);
                },
                false);
            xhr.addEventListener('abort',
                function (e) {
                    callback('cancel', e);
                },
                false);
        }
        xhr.open('POST', url);
        xhr.send(fd);
    };

    //音频采集
    recorder.onaudioprocess = function (e) {
        audioData.input(e.inputBuffer.getChannelData(0));
        //record(e.inputBuffer.getChannelData(0));
    };
};

export class WebRTC {

    /**
     * 获取授权弹窗
     */
    static getAuthorization(isConstraints, callback, failCallback) {    //isConstraints=false 取消授权
        var videoElement = document.getElementById('webcam');
        var audioSelect = document.querySelector('select#audioSource');
        var videoSelect = document.querySelector('select#videoSource');
        var selectCameraIcon = $("#selectCameraIcon");
        var selectUserVideo = $("#selectUserVideo");
        var cameraNumber = 0;
        var audioNumber = 0;

        // var canvas = document.querySelector('canvas');
        // var ctx = canvas.getContext('2d');
        var localMediaStream = null;

        if (isConstraints) {
            if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                navigator.mediaDevices.enumerateDevices()
                    .then(gotDevices).then(getStream).catch(handleError);
            } else {
                WebRTC.throwError('获取录音设备失败，请检查您的麦克风。');
                try {
                    if (/micromessenger/.test(navigator.userAgent.toLocaleLowerCase())) {
                        $('body').css({ "background": "#000", "text-align": "right" }).html('<img src="https://www.putaoabc.com/onlinepages/activity/download/img/guide.png" style="padding:20px;width:50%" />');
                    }
                } catch (err) {

                }
            }

            audioSelect.onchange = getStream;
            videoSelect.onchange = getStream;
        }

        function gotDevices(deviceInfos) {
            for (var i = 0; i !== deviceInfos.length; ++i) {
                var deviceInfo = deviceInfos[i];
                var option = document.createElement('option');
                option.value = deviceInfo.deviceId;
                if (deviceInfo.kind === 'audioinput') {
                    option.text = deviceInfo.label || 'microphone ' + (audioSelect.length + 1);
                    audioSelect.appendChild(option);
                    audioNumber++;
                } else if (deviceInfo.kind === 'videoinput' && deviceInfo.label !== "screen-capture-recorder") {
                    option.text = deviceInfo.label || 'camera ' + (videoSelect.length + 1);
                    videoSelect.appendChild(option);
                    cameraNumber++;
                } else {
                    // console.log('Found one other kind of source/device: ', deviceInfo);
                }
            }

            // 大于两个摄像头支持用户切换
            if (selectCameraIcon && selectCameraIcon.length && selectUserVideo && selectUserVideo.length && cameraNumber > 1) {
                selectCameraIcon.show().on("click", () => {
                    selectUserVideo.toggleClass("hide");
                });
            }
        }

        function getStream() {
            if (window.stream) {
                window.stream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }

            var ua = navigator.userAgent.toLocaleLowerCase();
            var isSafari = /safari/.test(ua) && !/chrome/.test(ua);

            var constraints = {};
            if (isConstraints.audio) {
                constraints.audio = isSafari ? true : {
                    deviceId: { exact: audioSelect.value }
                }
            }
            if (isConstraints.video) {
                constraints.video = isSafari ? true : {
                    deviceId: { exact: videoSelect.value },
                    width: 480,
                    height: 360
                }
            }

            selectUserVideo.addClass("hide");

            navigator.mediaDevices.getUserMedia(isConstraints ? constraints : {}).then(gotStream).catch(handleError);
        }

        function gotStream(stream) {
            window.stream = stream; // make stream available to console
            videoElement.srcObject = stream;
            localMediaStream = stream;  //截屏用的

            if (typeof callback === 'function') {
                callback(cameraNumber, audioNumber);
            }

            // 当媒体头信息就绪事件
            videoElement.onloadedmetadata = () => {
            }
        }

        function handleError(error) {
            console.log('Error: ', error);

            if (typeof failCallback === 'function') {
                failCallback();
            }

        }
    }


    /**
     * 获取录音机
     */
    //获取录音机
    static getHZRecorder(callback, config) {
        if (callback) {
            //兼容
            // navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.mediaDevices.getUserMedia;
            // if (navigator.mediaDevices.getUserMedia) {
            //     navigator.mediaDevices.getUserMedia({
            //         audio: true
            //     } //只启用音频
            //         , function (stream) {
            //             var rec = new HZRecorder(stream, config);
            //             callback(rec);
            //         }
            //         , function (error) {
            //             switch (error.code || error.name) {
            //                 case 'PERMISSION_DENIED':
            //                 case 'PermissionDeniedError':
            //                     WebRTC.throwError('用户拒绝提供信息。');
            //                     break;
            //                 case 'NOT_SUPPORTED_ERROR':
            //                 case 'NotSupportedError':
            //                     WebRTC.throwError('<a href="https://putaoabc.com/" target="_blank" class="keylink">浏览器</a>不支持硬件设备。');
            //                     break;
            //                 case 'MANDATORY_UNSATISFIED_ERROR':
            //                 case 'MandatoryUnsatisfiedError':
            //                     WebRTC.throwError('无法发现指定的硬件设备。');
            //                     break;
            //                 default:
            //                     WebRTC.throwError('无法打开麦克风。'); //异常信息： + (error.code || error.name)
            //                     break;
            //             }
            //         });
            // } else {
            //     this.throwErr('当前<a href="https://www.putaoabc.com/" target="_blank" class="keylink">浏览器</a>不支持录音功能。');
            //     return;
            // }

            //上面注释的写法在safari会报错
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({
                    audio: true
                }).then(function (stream) {
                    var rec = new HZRecorder(stream, config);
                    callback(rec);
                }).catch(function (error) {
                    switch (error.code || error.name) {
                        case 'PERMISSION_DENIED':
                        case 'PermissionDeniedError':
                            WebRTC.throwError('用户拒绝提供信息。');
                            break;
                        case 'NOT_SUPPORTED_ERROR':
                        case 'NotSupportedError':
                            WebRTC.throwError('浏览器不支持硬件设备。');
                            break;
                        case 'MANDATORY_UNSATISFIED_ERROR':
                        case 'MandatoryUnsatisfiedError':
                            WebRTC.throwError('无法发现指定的硬件设备。');
                            break;
                        default:
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                info: error,
                                stack: "getUserMedia"
                            }, window.EX_TYPE.mediaEx);
                            WebRTC.throwError('获取录音设备失败，请检查您的麦克风。'); //异常信息： + (error.code || error.name)
                            break;
                    }
                });
            } else {
                WebRTC.throwError('当前浏览器不支持录音功能。');
                return;
            }
        }
    }

    //抛出异常
    static throwError(message) {
        try {
            window.PuTaoA.showTips(message)
        } catch (err) {

        }
        // throw new
        //     function () {
        //         this.toString = function () {
        //             return message;
        //         };
        //     };
    }


    /**
     * 开始录制视频
     */
    static startRecordVideo() {
        if (typeof MediaRecorder === 'function') {
            window.isRecordingVideo = true;
            recordedBlobs = [];
            var options = {
                audioBitsPerSecond: 6000,  //128000,
                videoBitsPerSecond: 1500000 //2500000
            };
            if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
                options.mimeType = 'video/webm;codecs=h264';
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
                options.mimeType = 'video/webm;codecs=vp9';
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
                options.mimeType = 'video/webm;codecs=vp8';
            }
            try {
                mediaRecorder = new MediaRecorder(window.stream, options);
                // mediaRecorder.setOutputFormat(MediaRecorder.OutputFormat.MPEG_4);
                // mediaRecorder.setVideoSize(640, 480);
            } catch (e) {
                console.error('Exception while creating MediaRecorder: ' + e);
                alert('Exception while creating MediaRecorder: '
                    + e + '. mimeType: ' + options.mimeType);
                return;
            }
            // console.log('Created MediaRecorder', mediaRecorder, 'with options', options);

            mediaRecorder.onstop = function (event) {
                // console.log('Recorder stopped: ', event);
            }
            mediaRecorder.ondataavailable = function (event) {
                if (event.data && event.data.size > 0) {
                    recordedBlobs.push(event.data);
                }
            };
            mediaRecorder.start(10); // collect 10ms of data
            // console.log('MediaRecorder started', mediaRecorder);
        } else {
            try {
                window.PuTaoA.showTips('浏览器版本太低，会影响学习效果')
            } catch (err) {

            }
        }
    }
    //暂停媒体录制
    static pauseRecordVideo() {
        try {
            mediaRecorder.pause();
        } catch (err) {
        }
    }
    //继续录制之前被暂停的录制动作
    static resumeRecordVideo() {
        try {
            mediaRecorder.resume();
        } catch (err) {
        }
    }
    static stopRecordVideo(callback) {
        window.isRecordingVideo = false;
        try {   //2_100_1第2页唱完歌蓝屏，是这里调用stop报错，先加try
            mediaRecorder.stop();
        } catch (err) {
        }
        if (typeof callback === "function") {
            callback();
        }
        // console.log('Recorded Blobs: ', recordedBlobs);
    }
    static getRecordVideoBlob() {
        try {
            var superBuffer = new Blob(recordedBlobs, { type: 'video/webm' });
            // console.log(window.URL.createObjectURL(superBuffer));
            return superBuffer;
            // return window.URL.createObjectURL(superBuffer);
        } catch (e) {
        }
    }

}


// WEBPACK FOOTER //
// ./src/utils/WebRTC.js